import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Product } from '../models/Product';
import { BuyResponse } from '../models/BuyResponse';

@Injectable({
    providedIn: 'root',
})
export class StripeService {
    constructor(private http: HttpClient) {}

    getProducts(): Observable<Product[]> {
        const url = `/api/v1/products/?platform=stripe`;

        return this.http.get<Product[]>(url);
    }

    getOptions(): Observable<Product[]> {
        const url = `/api/v1/products/options?platform=stripe`;

        return this.http.get<Product[]>(url);
    }

    buy(product_ids: string[]): Observable<BuyResponse> {
        const url = `/api/v1/products/buy?platform=stripe`;
        const baseUrl = window.location.origin;
        const body: any = {
            product_ids: product_ids,
            success_url: `${baseUrl}/payment_success`,
            cancel_url: `${baseUrl}/payment_cancel`,
        };

        return this.http.post<BuyResponse>(url, body);
    }
}
